import * as Zod from 'zod';

import { translate } from 'utils/i18n';
import { dateTimeValidator } from 'common/validators/dateTime';
import { extraCategoryInputValidator } from 'common/validators/extraCategory';

export function getBudgetRequestFormValidator() {
    return Zod.object({
        title: Zod.string(translate('validate.required')).nonempty(
            translate('validate.required')
        ),
        amount: Zod.coerce
            .number<number>(translate('validate.mustBeANumber'))
            .nonnegative(translate('validate.zeroOrPositive'))
            .nullable()
            .refine((val) => val !== null, {
                message: translate('validate.required'),
            }),
        provider: Zod.string().optional().nullable(),
        link: Zod.string().optional().nullable(),
        startDate: dateTimeValidator.optional().nullable(),
        endDate: dateTimeValidator.optional().nullable(),
        groupId: Zod.string(translate('validate.required')).nonempty(
            translate('validate.required')
        ),
        description: Zod.string().optional().nullable(),
        extraCategories: extraCategoryInputValidator(true).optional(),
    }).refine(
        (data) => {
            if (!data.startDate || !data.endDate) return true;

            return data.startDate <= data.endDate;
        },
        {
            message: translate('budgetRequestForm.endDateBeforeStartDate'),
            path: ['endDate'],
        }
    );
}
